import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { moneyFormat } from "../../util/format";
import axios from "axios";
import { toast } from "react-toastify";

export const WishList = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const getData = () => {
    axios
      .get("/wish-list/shows")
      .then((res) => {
        const wishlistData = res.data.data?.wishlists;
        setProducts(wishlistData);
      })
      .catch((err) => console.log(err));
  };

  const handleRemoveItem = (id) => {
    axios
      .delete(`/wish-list/${id}`)
      .then(() => {
        getData();
        toast.success("xoá sản phẩm thành công");
      })
      .catch((err) => console.log(err));
  };

  if (products.length == 0) {
    return (
      <>
        <div className="container-fluid">
          <div className="row px-xl-5">
            <div className="col-12">
              <nav className="breadcrumb bg-light mb-30">
                <a className="breadcrumb-item text-dark" href="#">
                  Trang chủ
                </a>
                <span className="breadcrumb-item active">
                  Sản phẩm yêu thích
                </span>
              </nav>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            Chưa có sản phẩm yêu thích
            <div>
              <button
                className="btn btn-block btn-primary font-weight-bold my-3 py-3"
                onClick={() => {
                  navigate("/");
                }}
              >
                Quay về trang chủ
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <a className="breadcrumb-item text-dark" href="#">
                Trang chủ
              </a>
              <span className="breadcrumb-item active">Sản phẩm yêu thích</span>
            </nav>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="table-responsive mb-5">
            <table className="table table-light table-borderless table-hover mb-0">
              <thead className="bg-main text-white">
                <tr>
                  <th>Sản phẩm</th>
                  <th>Giá tiền</th>
                  <th>Hành động</th>
                </tr>
              </thead>
              <tbody className="align-middle">
                {products?.map((item, index) => (
                  <tr key={index}>
                    <td className="align-middle">
                      <div className="d-flex align-items-center">
                        <Link to={`/san-pham/${item?.product?.slug}`}>
                          <img
                            src={
                              item?.product?.imagesUrl?.[0] || "/logo192.png"
                            }
                            alt={item?.product?.name}
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </Link>
                        <Link
                          to={`/san-pham/${item?.product?.slug}`}
                          className="text-decoration-none text-dark"
                          style={{ fontWeight: "500" }}
                        >
                          {item?.product?.name}
                        </Link>
                      </div>
                    </td>
                    <td className="align-middle">
                      {moneyFormat(item?.product?.salePrice)}
                    </td>
                    <td className="align-middle">
                      <div className="d-flex">
                        <Link
                          to={`/san-pham/${item?.product?.slug}`}
                          className="btn btn-sm btn-primary mr-2"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveItem(item?.product?.id)}
                        >
                          <i className="fa fa-times"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
